module.exports = __webpack_public_path__ + "img/visa.8f7fcdf0.svg";